import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./StoryBuildingStep.module.scss";
import QuestionTextArea from "../QuestionTextArea/QuestionTextArea";

const StoryBuildingStep = ({ storyBeginning, storyMiddle, storyEnd }) => {
  return (
    <div className={cs(classes.storyBuildingStep)}>
        <h2 className={cs(classes.heading, classes.grandstanderFamily)}>
        Story Building 
      </h2>
      

      <div className={cs(classes.instructionBox)}>
        <h3 className={cs(classes.instructionTitle)}>You&apos;re almost there!</h3>
        <p className={cs(classes.instructionText)}>
          Now that you have a story in mind, let&apos;s break it down and make sure
          all the details come together.
        </p>
        <p className={cs(classes.instructionText)}>
          Write a 2-3 sentence summary on each part of the story.
        </p>
      </div>

      <div className={cs(classes.formSection)}>
        <QuestionTextArea
          id="story-beginning"
          label="Beginning: How does your story start?"
          value={storyBeginning.value}
          onChange={storyBeginning.onChange}
          placeholder="Long Answer text"
          error={storyBeginning.error}
          required={true}
          rows={3}
        />

        <QuestionTextArea
          id="story-middle"
          label="Middle: What goes wrong or gets complicated?"
          value={storyMiddle.value}
          onChange={storyMiddle.onChange}
          placeholder="Long Answer text"
          error={storyMiddle.error}
          required={true}
          rows={3}
        />

        <QuestionTextArea
          id="story-end"
          label="End: What happens in the end? How is the problem fixed?"
          value={storyEnd.value}
          onChange={storyEnd.onChange}
          placeholder="Long Answer text"
          error={storyEnd.error}
          required={true}
          rows={3}
        />
      </div>
    </div>
  );
};

const inputPropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
});

StoryBuildingStep.propTypes = {
  storyBeginning: inputPropTypes.isRequired,
  storyMiddle: inputPropTypes.isRequired,
  storyEnd: inputPropTypes.isRequired,
  errorMessage: PropTypes.string,
};

export default StoryBuildingStep;

